export default __webpack_public_path__ + "images/EI.4c31ce4.png";